export const API_CTIA_SERVICE = process.env.REACT_APP_CTIA_SERVICE;
export const API_SERVICE = process.env.REACT_APP_API_SERVICE;

export const COMPLAINTS_MAX_RESULTS = 10;

export const ERROR_CALLSIGN_API = 'API ERROR';
export const ERROR_FORM_GENERIC = 'ERROR_FORM_GENERIC';
